module.exports = __webpack_public_path__ + "static/media/icon-character__bertolt-brecht-hover.1de20511.svg";